(function () {
    //This checks for any alerts that have been dismissed in this session and hides them before the first paint to prevent flicker.
    //The rest of the alert script is in header.js, which handles the sticky header and alert dismissal.
    try {
        var prefix = 'alert-dismissed:', css = '';
        for (var i = 0; i < sessionStorage.length; i++) {
            var key = sessionStorage.key(i);
            if (key && key.indexOf(prefix) === 0 && sessionStorage.getItem(key) === 'true') {
                var id = key.slice(prefix.length);
                if (/^[\w-]+$/.test(id)) css += '#' + id + '{display:none!important}';
            }
        }
        if (css) {
            var style = document.createElement('style');
            style.textContent = css;
            document.head.appendChild(style);
        }
    } catch (e) {}
})();